






import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch }from 'vue-property-decorator';
import genericapi  from '../assets/ts/genericAPIAxios';

@Component
export default class EBiennialEmailApproval extends Vue {
 private store: any = this.$store;
  private label = [];
    private newObject: any = {};
    private created(): void {
      if (this.empty(this.label) || this.label.length === 0) {
      this.fetchLabels().then((labelResponse: any) => {
        console.log(labelResponse);
        this.label = labelResponse;
        });
      }
      console.log('Inside EBiennialLanding created method');
      const store = this.$store;
      this.newObject = JSON.parse(JSON.stringify(this.$store.getters['ebiennial/EBiennialFiling']));
      console.log(this.newObject);
    }
    private getLabelValue(label: string) {
    for (let i = 0; i < this.label.length; i++) {
      for (const key in this.label[i] ) {
        if (key === label) {
          console.log('Matched if');
          return this.label[i][key];
        }

      }
    }
  }
     private fetchLabels() {
     return genericapi.get('Generic/GetConfigurationData', {
          params: {
          group: 'SECTION',
          application: 'EBIENNIAL',
      },

    }).then((response: any) => {
      console.log(response);
      return response.data;
    }).catch((error: any) => {
      console.log(error);
    });
  }
    private empty(e) {
    switch (e) {
      case '':
      case '':
      case 0:
      case '0':
      case null:
      case false:
      case typeof this === 'undefined':
      case typeof this === undefined:
      return true;
      default:
        return false;
    }
  }
}
